import { render, staticRenderFns } from "./AreaBusiness.vue?vue&type=template&id=5c22c62f&scoped=true"
import script from "./AreaBusiness.vue?vue&type=script&lang=js"
export * from "./AreaBusiness.vue?vue&type=script&lang=js"
import style0 from "./AreaBusiness.vue?vue&type=style&index=0&id=5c22c62f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22c62f",
  null
  
)

export default component.exports